// extracted by mini-css-extract-plugin
export default {"menu":"BottomNav_menu__M9d7F"};